import { ISetScheduleParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetRunFlowTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setRunFlowTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId,
    });
  }
}
